/*
 * @Author: 廿夕 xuanwei@cai-inc.com
 * @Date: 2023-11-06 15:53:51
 * @LastEditors: 玄离 “hongyuanzhong@cai-inc.com“
 * @LastEditTime: 2024-05-30 18:06:42
 * @FilePath: /zcy-claim-front/src/router.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * 路由总入口文件
 * 通过getRouterData向layout中注入路由配置
 */
import Sky from '@zcy/zcy-zlb-sky-back';
import { mpSdk } from '@zcy/zlb-utils';
// import { ConfigProvider as ConfigProviderAntd } from 'antd';
import { ConfigProvider, Spin } from 'doraemon4';
import zhCN from 'doraemon4/es/locale/zh_CN';
import { Route, routerRedux } from 'dva/router';
import { parse } from 'qs';
import React, { Suspense } from 'react';
import { getRouterData } from './common/router';
import { EnvConfigProvider } from './env';
import ZcyLayout from './layouts/ZcyLayout';

const { ConnectedRouter } = routerRedux;

function RouterConfig({ history, app }) {
  const routerData = getRouterData(app);
  const searchObj = parse(window.location?.search?.slice(1));

  // @ts-ignore
  if (searchObj?.token) {
    sessionStorage.setItem('isFromDingTalk', '1');
  }

  // 0-登录 1-退出
  const handleLogin = async type => {
    try {
      if (!mpSdk.env.isZzd) return;
      // 获取用户信息
      const userInfo_zzd = await mpSdk.getAuthCode();
      const userCode = userInfo_zzd?.code || userInfo_zzd?.auth_code;
      // 登录
      if (type === 0) {
        // eslint-disable-next-line no-undef
        sensors_sw.login(userCode);
      }
      //退出
      else {
        // eslint-disable-next-line no-undef
        sensors_sw.logout();
      }
    } catch (error) {
      console.log('handleLogin====error', error);
    }
  };

  return (
    <Sky
      history={history}
      hide={window.__POWERED_BY_QIANKUN__}
      dingCount="dingCount"
      loginCallback={handleLogin}
    >
      <EnvConfigProvider>
        <ConfigProvider locale={zhCN} prefixCls="ant4" iconPrefixCls="ant4icon">
          <Suspense
            fallback={
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  margin: 'auto',
                  paddingTop: 50,
                  textAlign: 'center',
                }}
              >
                <Spin />
              </div>
            }
          >
            <ConnectedRouter history={history}>
              <Route
                path="/"
                render={props => <ZcyLayout routerData={routerData} {...props} />}
                redirectPath="/exception/403"
              />
            </ConnectedRouter>
          </Suspense>
        </ConfigProvider>
      </EnvConfigProvider>
    </Sky>
  );
}

export default RouterConfig;
